import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteRole = (organisationId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (roleId: string) => {
      const response = await fetch(
        `${APIBaseChronos}/api/roles/${roleId}${organisationId ? `?orgId=${encodeURIComponent(organisationId)}` : ''}`,
        getFetchConfig({ method: FetchMethod.DELETE }),
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message ?? 'Failed to delete role');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.Roles, { organisationId }]);
      toast.success('Role deleted successfully');
    },
    onError: (error) => {
      toast.error(error.message ?? 'Failed to delete role');
    },
  });
};
